import CustomizedSwitch from 'components/SwitchButton/SwitchButton';
import { Flex } from 'components/ui/flex';

const PriceSettingToggle: React.FC<{
  title: string;
  description: string;
  action: () => void;
  isOn: boolean;
  disabled: boolean;
}> = ({ title, description, action, isOn, disabled }) => {
  return (
    <Flex
      direction="row"
      align="center"
      justify="between"
      className="settings-card mt-4 p-9"
    >
      <div style={{ maxWidth: '50%' }}>
        <h3 className="text-base-cardForeground font-semibold">{title}</h3>
        <p className="mt-2 small-text">{description}</p>
      </div>
      <div>
        <div className="buttons-wrapper">
          <CustomizedSwitch
            tooltip={''}
            status={isOn}
            texts={[]}
            functions={[() => action(), () => action()]}
            disabled={disabled}
            color="black"
          />
        </div>
      </div>
    </Flex>
  );
};

export default PriceSettingToggle;
